<template>
  <div class="row" v-if="aviso.docaviso_ficheiros.length > 0">
    <div class="small-12 medium-12 large-10 columns fcolumn">
      <div class="row doc_concursos">
        <DocAviso :file="file" 
          :key="file.doc_ficheiros_url"
          v-for="file in aviso.docaviso_ficheiros" />
      </div>
    </div>
  </div>
</template>

<script>
import DocAviso from "@/components/aviso/DocAviso.vue";

export default {
  components:{
    DocAviso
  },
  props:["aviso"]
}
</script>

<style lang="scss" scoped>
.doc_concursos {
  padding-bottom: 60px;
}

.fcolumn {
  padding-right: 40px;
  padding-left: 50px;
  padding-bottom: 5px;
}

@media (max-width: 767px){
  .fcolumn{
    padding-right: 15px;
    padding-left: 15px;
  }
}

</style>